module.exports = __webpack_public_path__ + "img/支付宝.66b470ad.png";